<template lang="pug">
#SourceProfileIdentity

    .box(v-if="load_data_status_search_by_name_personal_identity.status === 'loading'")
        .box__body.p-4
            Loading(show="true")

    template(v-else)

        .grid.grid-cols-4.gap-8(v-if="search_by_name_personal_identity.possible_persons && search_by_name_personal_identity.possible_persons.length > 0")
            .box(style="margin-bottom: 0px;" v-for="person in search_by_name_personal_identity.possible_persons")
                .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            h2.subheading Match
                        .header-cta.flex.items-center
                            //- router-link.link-text(to="#") Visit account
                            //- span {{ person['@match'] || person['@match'] === 0 ? person['@match'] : '-' }}
                            span {{ person['@match'] || person['@match'].length !== 0 ? Number.parseFloat(person['@match'] * 100) + ' %' : '-' }}

                .box__body.p-4
                    //- .block.mb-4
                        span.block.mb-1 Match
                        router-link.link-text.block(to="#" target="_blank") {{ person['@match'] ? person['@match'] : '-' }}
                        
                    //- first name & last name
                    //- template(v-if="keyword_type.name_arr && keyword_type.name_arr.length > 1")
                    .block.mb-4
                        span.block.mb-1 Names
                        .block.text-white
                            template(v-if="person.names && person.names.length > 0")
                                span(v-for="name,index_name in person.names") {{ name.display ? (name.display + ((index_name+1) != person.names.length ? ', ' : '')) : '-' }}
                            template(v-else) -

                    .block.mb-4
                        span.block.mb-1 Usernames
                        .block.text-white
                            template(v-if="person.usernames && person.usernames.length > 0")
                                span(v-for="username,index_username in person.usernames") {{ username.content ? (username.content + ((index_username+1) != person.usernames.length ? ', ' : '')) : '-' }}
                            template(v-else) -
                    
                    .block.mb-4
                        span.block.mb-1 Gender
                        .block.text-white {{ person.gender && person.gender.content ? person.gender.content : '-' }}

                    .block.mb-4
                        span.block.mb-1 DOB
                        .block.text-white {{ person.dob && person.dob.display && person.dob.date_range.start ? person.dob.date_range.start +' ('+ person.dob.display +')' : '-' }}

                    .block.mb-4
                        span.block.mb-1 Languages
                        .block.text-white
                            template(v-if="person.languages && person.languages.length > 0")
                                span(v-for="language,index_language in person.languages") {{ language.display ? (language.display + ((index_language+1) != person.languages.length ? ', ' : '')) : '-' }}
                            template(v-else) -

                    .block.mb-4
                        span.block.mb-1 Phones
                        .block.text-white
                            template(v-if="person.phones && person.phones.length > 0")
                                span(v-for="phone,index_phone in person.phones") {{ phone.number && phone.number.toString() ? (phone.country_code.toString() + phone.number.toString() + ((index_phone+1) != person.phones.length ? ', ' : '')) : '-' }}
                            template(v-else) -

                    .block.mb-4
                        span.block.mb-1 Addresses
                        .block.text-white
                            template(v-if="person.addresses && person.addresses.length > 0")
                                span(v-for="address,index_address in person.addresses") {{ address.display ? (address.display + ((index_address+1) != person.addresses.length ? ', ' : '')) : '-' }}
                            template(v-else) -

                    .block.mb-4
                        span.block.mb-1 Educations
                        .block.text-white
                            template(v-if="person.educations && person.educations.length > 0")
                                span(v-for="education,index_education in person.educations") {{ education.display ? (education.display + ((index_education+1) != person.educations.length ? ', ' : '')) : '-' }}
                            template(v-else) -

                    .block.mb-4
                        span.block.mb-1 Relationships
                        .block.text-white
                            template(v-if="person.relationships && person.relationships.length > 0")
                                //- span(v-for="relationship,index_relationship in person.relationships") {{ relationship.display ? (relationship.display + ((index_relationship+1) != person.relationships.length ? ', ' : '')) : '-' }}
                                span(v-for="relationship,index_relationship in person.relationships")
                                    template(v-if="relationship.names && relationship.names.length > 0")
                                        span(v-for="relation,index_relation in relationship.names")
                                            | {{ relation.display ? (relation.display + (relationship['@subtype'] ? ' ('+ relationship['@subtype'] +')' : ' ('+ relationship['@type'] +')' ) + ((index_relation+1) != relationship.length ? ', ' : '')) : '-' }}
                            template(v-else) -

                    .block
                        span.block.mb-1 Image
                        .block.text-white
                            template(v-if="person.images && person.images.length > 0")
                                img(v-for="image in person.images" :src="image.url" @error="imgError($event)")
                            span(v-else) -

        .box(v-else)
            NoDataAvailable

</template>

<script>
import { mapState } from 'vuex';
import { encrypt,decrypt } from '@/util/crypto';
import Spinner from '@/components/Spinner.vue';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

export default {
    name: 'SourcePersonalIdentity',
    components: {
        Spinner,
        Loading,
        NoDataAvailable,
    },
    data(){
        return {
            filterShow: false,
        }
    },
    computed: {
        ...mapState([
            'load_data_status_search_by_name_personal_identity',
            'search_by_name_personal_identity',
        ]),
        route_name() {
            return this.$route.name;
        },
        key() {
            return this.$route.params.key;
        },
        isKey() {
            // return this.key!==undefined ? true : false;
            return this.key ? true : false;
        },
        keyword_type() {

            let decrypt_data = decrypt(this.key);
            decrypt_data = decrypt_data.split('&&');

            decrypt_data['name_arr'] = decrypt_data[0].split(' ');

            return decrypt_data;
        },
        year_of_birth: {
            get() {
                let data = this.year_of_birth_data;
                // if (this.year_of_birth_data === '') {
                //     const finish_year = new Date().getFullYear();
                //     data = finish_year - 16;
                // }

                return data;
            },
            set(v) {
                this.year_of_birth_data = v;
            },
        },
        year_of_birth_options() {
            const start_year = 1900;
            const finish_year = new Date().getFullYear();

            let options = [];
            let count_year = finish_year;

            for (var i = (finish_year + 1); i >= (start_year + 1); i--) {
                options.push(count_year--);
            }

            return options;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageName') {
                if (oldData !== 'PageName') {
                    this.items_per_page = 10;
                    this.page = 0;
                    // this.keyword = '';
                    // this.$store.commit('setSearchByNamePersonalIdentity', {});
                }
                // this.getData();
            }
        },
        key() {
            // this.page = 0;
            // this.getData(true);
            this.$store.commit('setSearchByNamePersonalIdentity', {});
        },
        isKey() {},
        breadcrumb() {},

        search_by_name_marketplace(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        gender() {},
        year_of_birth() {},
        year_of_birth_options() {},
        // birth_date() {},
        age_min() {},
        age_max() {},
    },
    methods: {
        encrypt(key, type) {

            // remove space in prefix
            if (key.substr(0, 1) === ' ')
                key = key.substr(1, (key.length - 1));

            if (type === 'msisdn') {

                let prefix_key = key.substr(0, 1);

                if (prefix_key === 0 || prefix_key === '0') {
                    key = '62' + key.substr(1, (key.length - 1));
                } else if (key.substr(0, 4) === '+620') {
                    key = '62' + key.substr(4, (key.length - 4));
                } else if (prefix_key === '+') {
                    key = key.substr(1, (key.length - 1));
                }
            }

            return encrypt(key + '&&' + type);
        },
        calculateAge(dob) {

            dob = dob.split('-');
            let date = new Date(parseInt(dob[0]), (parseInt(dob[1]) - 1), parseInt(dob[2]));
            
            var diff_ms = new Date() - date.getTime();
            var age_dt = Math.floor(diff_ms / (1000 * 60 * 60 * 24 * 365.2425));

            return age_dt;
        },
        async getData(filter=false) {
            if (this.route_name === 'PageName' ) {
                // const default_date = this.$store.getters.getDefaultDate();

                // this.dateRange.startDate = moment(default_date.from_date, 'YYYY-MM-DD').toDate();
                // this.dateRange.endDate = moment(default_date.end_date, 'YYYY-MM-DD').toDate();

                // this.from_date = moment(this.dateRange.startDate).format('YYYY-MM-DD');
                // this.to_date = moment(this.dateRange.endDate).format('YYYY-MM-DD');

                if (this.isKey) {

                    if (filter)
                        this.page = 0;

                    let decrypt_data = decrypt(this.key);
                    decrypt_data = decrypt_data.split('&&');

                    var key = decrypt_data[0];
                    // var type = decrypt_data[1];

                    this.keyword = key;

                    // gender='', birth_date='', age_min='', age_max=''

                    // await this.$store.dispatch('getSearchByNamePersonalIdentity', [key, this.items_per_page, (this.page + 1), this.gender, this.birth_date, this.age_min, this.age_max]);
                    await this.$store.dispatch('getSearchByNamePersonalIdentity', [key]);
                    
                } else {
                    this.$store.commit('setSearchByNamePersonalIdentity', {});
                }                
            }
        },
        reset() {

            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset?',
                // text: 'Role : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');
                if (result.isConfirmed) {
                    this.gender = '';
                    this.year_of_birth = '';
                    this.age_min = '';
                    this.age_max = '';

                    this.getData(true);
                }
            });

        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        imgError(e) {
            e.target.classList.add('hide-img')
            // console.log(url)
        },
    },
    mounted() {
        // console.log('on marketplace')
        EventEmit.$on('openSearchByNamePersonalIdentity', () => {
            // this.getData();
            // if (this.page !== 0) {
            //     this.page = 0;
            // } else {
                this.getData();
            // }
        });
    },
}
</script>

<style lang="sass" scoped="">
    .hide-img
        display: none
</style>